import React from "react";

import { Tabs } from "antd";
import { StickyContainer, Sticky } from "react-sticky";
import "../tabs.css"; 
import DatosSolicitantesSection from "./sections/DatosSolicitantesSection"; 
import DatosAnalisisSection from "./sections/DatosAnalisisSection"; 
import DatosProyectoSection from "./sections/DatosProyectoSection"; 
import GastosOperativosSection from "./sections/GastosOperativosSection"; 
import ResumenCompraSection from "./sections/ResumenCompraSection"; 
import PagoServicioSection from "./sections/PagoServicioSection";  
import { BasePage } from "../../../../framework/pages/BasePage"; 
import { LoadUtil } from "../../../../framework/util/LoadUtil";
 
export class PlanificacionCotizacionesPage extends BasePage {

 
  constructor(props) {
    super(props);
    this.state = {
      // validarDatosAnalisisSection: false, 
      id_doc: null,
      keyPanel: "1"
    }  
     this.cambiarTabPanel = this.cambiarTabPanel.bind(this)
  }

   cambiarTabPanel(tab,id_doc) {
        this.setState({
        // validarDatosAnalisisSection: true,
        id_doc: id_doc,
        keyPanel: tab,
        keyPrincipal: tab,
      }) 
   }


  createPageProperties = (pageApi) => {
    return {
      // title: 'Fields'
    };
  };

  componentDidMount() { 
     let estado_tab = window.location.pathname.split('/')[3]
    //  let obtenerId = window.location.pathname.split('/')[4]
     
     if(estado_tab === "new"){
      this.setState({ 
        keyPanel: "1",
        keyPrincipal: "1"
        })  
     }
     else {
      this.setState({
        // id_doc: obtenerId,
        keyPanel: estado_tab,
        keyPrincipal: estado_tab
        })  
     }

   }
 
  renderPage(pageApi,keyPanel) {
    const { TabPane } = Tabs;

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    return (
      <>
        <StickyContainer>
          <Tabs destroyInactiveTabPane={true} activeKey={this.state.keyPanel} renderTabBar={renderTabBar} onChange={(key) => this.setState({ keyPanel: key })}>
            <TabPane tab="Datos del Solicitante" key="1">
              <DatosSolicitantesSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
              {/* { <DatosSolicitantesSection api={pageApi}  /> } */}
            </TabPane> 
 
            <TabPane tab="Datos de Analisis" key="2" disabled={parseInt(this.state.keyPrincipal) < 2} > 
            < DatosAnalisisSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/> 
            </TabPane>

            <TabPane tab="Datos del Proyecto" key="3" disabled={parseInt(this.state.keyPrincipal) < 3}> 
              < DatosProyectoSection  api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/> 
             </TabPane>
         
            <TabPane tab="Gastos Operativos" key="4"  disabled={parseInt(this.state.keyPrincipal) < 4}> 
              < GastosOperativosSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/> 
             </TabPane> 
      
           <TabPane tab="Resumen de Compra" key="5" disabled={parseInt(this.state.keyPrincipal) < 5}> 
              < ResumenCompraSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/> 
             </TabPane>

            <TabPane tab="Pago de Servicio" key="6" disabled={parseInt(this.state.keyPrincipal) < 6 }> 
              < PagoServicioSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/> 
             </TabPane> 
     
          </Tabs>
        </StickyContainer>
      </>
    );
  }
}